import { List, Stack, Text, Title } from '@mantine/core';

export const UserAgreements = () => {
    return (
        <Stack gap="md">
            <Title order={3}>User Agreements</Title>

            <Text>Before accessing Panasonic Cloud services, you may be asked to accept the Terms of Use.</Text>

            <Title order={4} td="underline">When You Will See This</Title>

            <List spacing="sm">
                <List.Item>The first time you sign in to a new account</List.Item>
                <List.Item>When the Terms of Use have been updated</List.Item>
            </List>

            <Title order={4} td="underline">How to Accept</Title>

            <List type="ordered" spacing="sm">
                <List.Item>Read the Terms of Use presented on screen</List.Item>
                <List.Item>Click "Accept" to agree and continue</List.Item>
                <List.Item>You will be redirected to your application</List.Item>
            </List>

            <Text>You must accept the Terms of Use to continue using Panasonic Cloud services. If you decline, you will not be able to access the application.</Text>
        </Stack>
    );
};
